import { useEffect } from "react";
import { Link } from "react-router-dom";
import useSWR from "swr";
import { fetcher } from "../../lib/api";
import { useStore } from "../../context/StoreContext";
import BannerCarousel from "../../components/public/BannerCarousel";
import { ProductGrid, SectionTitle } from "../../components/public/ProductGrid";

const CATEGORIES = [
  { label: "Masculinos", to: "/catalogo?gender=masculino", sub: "Intensos e marcantes" },
  { label: "Femininos", to: "/catalogo?gender=feminino", sub: "Elegância envolvente" },
  { label: "Unissex", to: "/catalogo?gender=unissex", sub: "Para todas as presenças" },
];

const opts = { refreshInterval: 60000 };

export default function Home() {
  const { settings } = useStore();
  const { data: banners } = useSWR("/public/banners", fetcher, { refreshInterval: 30000 });
  const { data: featured } = useSWR("/public/products?tag=featured&limit=8", fetcher, opts);
  const { data: launches } = useSWR("/public/products?tag=launch&limit=4", fetcher, opts);
  const { data: promos } = useSWR("/public/products?tag=promo&limit=4", fetcher, opts);
  const { data: latest } = useSWR("/public/products?limit=8", fetcher, opts);

  useEffect(() => {
    document.title = "EMAIA PERFUMES | Perfumes Árabes";
  }, []);

  const fallback = settings
    ? { id: "hero", image: settings.hero_image || "/images/hero.jpg", title: settings.hero_title, description: settings.hero_subtitle, button_label: "Ver catálogo", link: "/catalogo" }
    : null;
  const showcase = featured?.length ? featured : latest;
  const empty = latest && latest.length === 0;

  return (
    <div data-testid="home-page">
      {banners !== undefined && <BannerCarousel banners={banners} interval={settings?.banner_interval} fallback={fallback} />}

      <section className="mx-auto -mt-12 grid max-w-7xl grid-cols-1 gap-4 px-5 sm:grid-cols-3 lg:px-8">
        {CATEGORIES.map((c, i) => (
          <Link key={c.label} to={c.to} style={{ animationDelay: `${i * 120}ms` }} className="fade-up group relative z-10 overflow-hidden rounded-2xl border border-[#D4AF37]/20 bg-[#141417]/95 p-7 backdrop-blur transition-[border-color] hover:border-[#D4AF37]/60" data-testid={`home-category-${c.label.toLowerCase()}`}>
            <p className="eyebrow">{c.sub}</p>
            <p className="mt-2 font-serif text-3xl text-[#FAF6F0] transition-colors group-hover:text-[#F3E5AB]">{c.label}</p>
            <span className="absolute bottom-6 right-6 text-[#D4AF37] transition-transform group-hover:translate-x-1">→</span>
          </Link>
        ))}
      </section>

      {empty && (
        <section className="mx-auto max-w-3xl px-5 py-28 text-center" data-testid="home-empty-catalog">
          <p className="eyebrow mb-4">Coleção EMAIA</p>
          <h2 className="font-serif text-4xl text-[#FAF6F0]">Nossa coleção está sendo preparada</h2>
          <p className="mt-4 text-[#A1A1AA]">Em breve, as fragrâncias estarão disponíveis aqui. Fale conosco pelo WhatsApp para atendimento personalizado.</p>
        </section>
      )}

      {showcase?.length > 0 && (
        <section className="mx-auto max-w-7xl px-5 pt-24 lg:px-8">
          <SectionTitle eyebrow={featured?.length ? "Destaques" : "Coleção"} title={featured?.length ? "Seleção da casa" : "Nossas fragrâncias"} link="/catalogo" />
          <ProductGrid items={showcase} testid="home-featured-grid" />
        </section>
      )}

      {launches?.length > 0 && (
        <section className="mx-auto max-w-7xl px-5 pt-24 lg:px-8">
          <SectionTitle eyebrow="Lançamentos" title="Recém-chegados" link="/catalogo?tag=launch" />
          <ProductGrid items={launches} testid="home-launch-grid" />
        </section>
      )}

      {promos?.length > 0 && (
        <section className="mx-auto max-w-7xl px-5 pt-24 lg:px-8">
          <SectionTitle eyebrow="Promoções" title="Ofertas especiais" link="/catalogo?tag=promo" />
          <ProductGrid items={promos} testid="home-promo-grid" />
        </section>
      )}
    </div>
  );
}
